import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiExpenses from '../../Api/ApiExpenses';
import ToastMsg from '../../Components/ToastMsg';
import { creators as ExpensesActions } from '../../Reducers/Reporting/Expenses';

export function* getExpensesSummary({ payload }) {
  try {
    const response = yield call(ApiExpenses.getSummary, payload.selectedYears);

    if (response.status === 200) {
      yield put(ExpensesActions.expensesSuccess({ summaryData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Expenses Summary',
            text: response.message,
          },
        },
      );
      yield put(ExpensesActions.expensesFailure(response.message));
    }
  } catch (e) {
    yield put(ExpensesActions.expensesFailure(e));
  }
}

export function* getExpensesDetail({ payload }) {
  try {
    const response = yield call(ApiExpenses.getDetail, payload.selectedYears);

    if (response.status === 200) {
      yield put(ExpensesActions.expensesSuccess({ detailData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Expenses Detail',
            text: response.message,
          },
        },
      );
      yield put(ExpensesActions.expensesFailure(response.message));
    }
  } catch (e) {
    yield put(ExpensesActions.expensesFailure(e));
  }
}
